import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// const originalReplace = VueRouter.prototype.replace;
// VueRouter.prototype.replace = function replace(location) {
//   return originalReplace.call(this, location).catch((err) => err);
// };

const routes = [
  {
    path: "/",
    name: "Home",
    meta: {
      isMaster: true,
      isFloating: true
    },
    component: () => import("../views/Home.vue")
  },
  {
    path: "/category/:id",
    name: "Category",
    component: () => import("../views/List.vue")
  },
  {
    path: "/expertise",
    name: "Expertise",
    meta: {
      title: "我们的专长 - Sisley Paris",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("../views/Expertise.vue")
  },
  {
    path: "/landing",
    name: "Landing",
    meta: {
      title: "希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      }
    },
    component: () => import("@/views/LandingPage.vue")
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      title: "用户注册 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("../views/Register.vue")
  },
  {
    path: "/complete",
    name: "Complete",
    meta: {
      title: "完善资料 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("../views/myaccount/Complete.vue")
  },
  {
    path: "/improve",
    name: "ImproveInfo",
    meta: {
      title: "希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("../views/ImproveInfo.vue")
  },
  {
    path: "/detail",
    name: "Detail",
    component: () => import("../views/Detail.vue")
  },
  {
    path: "/try",
    name: "PostTrial",
    component: () => import("../views/PostTrial.vue")
  },
  {
    path: "/checkout",
    name: "Checkout",
    meta: {
      title: "订单结算 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("../views/Checkout.vue")
  },
  {
    path: "/trialconfirm",
    name: "TrialConfirm",
    meta: {
      title: "付邮试用 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      requireAuth: true,
      disableLayout: true
    },
    component: () => import("../views/TrialConfirm.vue")
  },
  {
    path: "/myaccount",
    redirect: "myaccount/myaccount",
    meta: {
      title: "个人中心 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      isFloating: false,
      requireAuth: true
    },
    component: () => import("@/views/myaccount/account.vue"),
    children: [
      {
        path: "myaccount",
        name: "Myaccount",
        meta: {
          title: "我的账户 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("@/views/myaccount/myaccount.vue")
      },
      {
        path: "orders",
        name: "MyOrders",
        meta: {
          title: "我的订单 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("@/views/myaccount/Orders.vue")
      },
      {
        path: "club",
        name: "Club",
        meta: {
          title: "我的俱乐部 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("@/views/myaccount/Club.vue")
      },
      {
        path: "profile",
        name: "Profile",
        meta: {
          title: "我的个人信息 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("@/views/myaccount/profile.vue")
      },
      {
        path: "address",
        name: "Address",
        meta: {
          title: "我的地址簿 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("@/views/myaccount/Address.vue")
      },
      {
        path: "coupon",
        name: "Coupon",
        meta: {
          title: "我的优惠券 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("@/views/myaccount/Coupon.vue")
      },
      {
        path: "history",
        name: "History",
        meta: {
          title: "我的足迹 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("../views/myaccount/History.vue")
      },
      {
        path: "favorites",
        name: "Favorites",
        meta: {
          title: "我的收藏 | 希思黎",
          content: {
            description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
          },
          isMaster: true,
          requireAuth: true
        },
        component: () => import("../views/myaccount/Favorites.vue")
      },
      // {
      //   path: "mall",
      //   name: "MallWrap",
      //   meta: {
      //     title: "积分商城 | 希思黎",
      //     content: {
      //       description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。",
      //     },
      //     isMaster: true,
      //     requireAuth: true
      //   },
      //   redirect: "mall/list",
      //   component: () => import("../views/myaccount/MallWrap.vue"),
      //   children: [
      //     {
      //       path: "list",
      //       name: "MallList",
      //       meta: {
      //         title: "积分商城 | 希思黎",
      //         isMaster: true,
      //         requireAuth: true
      //       },
      //       component: () => import("../views/myaccount/MallList.vue")
      //     },
      //     {
      //       path: "history",
      //       name: "MallHistory",
      //       meta: {
      //         title: "积分商城 | 希思黎",
      //         isMaster: true,
      //         requireAuth: true
      //       },
      //       component: () => import("../views/myaccount/MallHistory.vue")
      //     },
      //   ],
      // },
    ]
  },
  {
    path: "/cart",
    name: "Cart",
    meta: {
      title: "我的购物袋 - Sisley Paris",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("../views/Cart.vue")
  },
  {
    path: "/pay",
    name: "OrderPay",
    meta: {
      title: "Sisley法国希思黎中国官方网站:享誉全球的奢华植物美容品牌 - Sisley Paris",
      isMaster: true,
      disableLayout: true
    },
    component: () => import("../views/OrderPay.vue")
  },
  {
    path: "/hair-rituel",
    name: "HairRituel",
    meta: {
      title: "Hair Rituel by Sisley - Sisley Paris",
      isMaster: false,
      isFloating: true
    },
    component: () => import("../views/HairRituel.vue")
  },
  {
    path: "/legal",
    name: "LegalStatement",
    meta: {
      title: "法律声明 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/LegalStatement.vue")
  },
  {
    path: "/privacy",
    name: "Privacy",
    meta: {
      title: "隐私政策 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/Privacy.vue")
  },
  {
    path: "/terms",
    name: "TermsAndConditions",
    meta: {
      title: "条款和条件 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/TermsAndConditions.vue")
  },
  {
    path: "/groupe",
    name: "Groupe",
    meta: {
      title: "集团介绍 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("@/views/Groupe.vue")
  },
  {
    path: "/fondation",
    name: "Fondation",
    meta: {
      title: "公司慈善 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("@/views/Fondation.vue")
  },
  {
    path: "/friedland",
    name: "Friedland",
    meta: {
      title: "公司文化 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("@/views/Friedland.vue")
  },
  {
    path: "/friedland-detail",
    name: "FriedlFriedlandDetailand",
    meta: {
      title: "公司文化 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("@/views/FriedlandDetail.vue")
  },
  {
    path: "/samples",
    name: "PersonalizedSample",
    meta: {
      title: "个性化样品 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/PersonalizedSample.vue")
  },
  {
    path: "/gifts",
    name: "GiftCustomization",
    meta: {
      title: "礼品定制 | 希思黎",
      content: {
        description: "您在希思黎官方商城上购买的商品都将被装在希思黎定制的精美礼盒中发货。若购物的产品作为礼物，我们都将为您代写定制留言，并将祝福贺卡放入礼盒内一起发货。"
      },
      isMaster: true
    },
    component: () => import("@/views/GiftCustomization.vue")
  },
  {
    path: "/faq",
    name: "FrequentlyAskedQuestions",
    meta: {
      title: "常见问题 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/FAQ.vue")
  },
  {
    path: "/member-club",
    name: "MemberClub",
    meta: {
      title: "会员计划 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/MemberClub.vue")
  },
  {
    path: "/store-finder",
    name: "StoreFinder",
    meta: {
      title: "店铺导航 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/StoreFinder.vue")
  },
  {
    path: "/sitemap",
    name: "SiteMap",
    meta: {
      isMaster: true,
      disableLayout: false
    },
    component: () => import("@/views/SiteMap.vue")
  },
  {
    path: "/payquery",
    name: "PayQuery",
    meta: {
      isMaster: true
    },
    component: () => import("@/views/PayQuery.vue")
  },
  {
    path: "/payresult",
    name: "PayResult",
    meta: {
      isMaster: true
    },
    component: () => import("@/views/PayResult.vue")
  },
  {
    path: "/notre-univers",
    name: "NotreUnivers",
    meta: {
      title: "进入Sisley的世界 | 希思黎",
      content: {
        keywords: '品牌, 专业知识, 世界, 故事, 价值观, 护肤,化妆品, 彩妆, 植物美容学, 科研, 研究, 革新, 创新, 美容, 环境, 环保, 艺术, 基金会, 背景, 价值, 源自法国, 法国制造, 公司, 企业',
        description: "探索勇于创新的法国家族企业 ── Sisley的独特世界，以及其在植物美容领域的专业知识"
      },
      isMaster: true
    },
    component: () => import("@/views/static/OurUniverse.vue")
  },
  {
    path: "/expertise-sisley",
    name: "TheSisleyExpertise",
    meta: {
      title: "专业知识 | 希思黎",
      content: {
        keywords: '专业, 护肤, 研究所, 研究, 成份, 产品, 美容, 感官, 成效, 皮肤, 知识, 植物美容, 大自然, 植物, 配方, 科学, 化妆品, 彩妆, 无害, 活跃, 自然,抗老化, 抗衰老, 蔬菜, 能量, 萃取, 科技, 技术.',
        description: "Sisley对于肌肤保养拥有高度专业的认知，它的护理产品结合了崭新的科研技术和优异的天然植物成分。"
      },
      isMaster: true
    },
    component: () => import("@/views/static/ExpertiseSisley.vue")
  },
  {
    path: "/foundation",
    name: "Foundation",
    meta: {
      title: "Sisley多纳诺基金会 (Sisley-d'Ornano Foundation) | 希思黎",
      content: {
        keywords: 'Sisley、基金会、艺术、艺术领域、项目、慈善、Ornano、多纳诺家族, 协会、学生、奖学金、儿童、修复、贡献、支持、承诺、女性、贫困人口、医学研究、文化、环境、社会项目、健康、教育、团结',
        description: "Sisley多纳诺基金会成立数十年来，致力于医疗健康、团结互助、教育、文化和环境保护等不同领域，由源头支持改变的发生。",
      },
      menuThem: 'white',
      isMaster: true,
      isFloating: true
    },
    component: () => import("@/views/static/FoundationSisley.vue")
  },
  {
    path: "/sisley-x-environment",
    name: "sisley-x-environment",
    meta: {
      title: "Sisley与环境 - Sisley Paris",
      content: {
        keywords: 'Sisley是一家创立於法国的家族企业，将环保视為发展的重中之重。',
        description: "Sisley，企业，法国公司，环境，生态责任，能源，创新，化妆品，环境足跡，自然。",
      },
      menuThem: 'white',
      isMaster: true,
    },
    component: () => import("@/views/static/SisleyXEnvironment.vue")
  },
  {
    path: "/art-creation",
    name: "ArtCreation",
    meta: {
      title: "艺术与创作 | 希思黎",
      content: {
        keywords: '艺术，家庭，创作，美容，香水，香氛，雕塑，瓶身设计，盒子，插画，拼布，性质，颜色，基金会，现代美术，艺术，艺术家，学院，绘画。',
        description: "Sisley和多纳诺(d'Ornano)家族的故事与艺术的世界有着紧密的连结。"
      },
      isMaster: true
    },
    component: () => import("@/views/static/ArtCreation.vue")
  },
  {
    path: "/sisley-x-environment",
    name: "LaBeauteRaisonnee",
    meta: {
      title: "永续美丽 | 希思黎",
      content: {
        keywords: '美容，化妆品，彩妆，环境，公司，能源，气候，运输，绿色，生态学，足迹，足印, 自然，污染，经济，责任，来源，成分，质量，健康。',
        description: "Sisley 致力于实施一系列措施，在研发卓越优质产品的同时减少生态足迹。"
      },
      isMaster: true
    },
    component: () => import("@/views/static/BeautifulReason.vue")
  },
  {
    path: "/entreprise",
    name: "Entreprise",
    meta: {
      title: "关于公司 | 希思黎",
      content: {
        keywords: '公司, 企业, 员工, 家族, 植物美容, 分公司, 店铺, 专柜, 美容, 美妆, 产品, 推广, 企业精神, 彩妆, 护肤, 国际, 法国, 香氛, 香水。',
        description: "Sisley是一家法国企业，在全球拥有约4,500名员工，业务遍及五大洲。"
      },
      isMaster: true
    },
    component: () => import("@/views/static/Entreprise.vue")
  },
  {
    path: "/jump",
    name: "Jump",
    meta: {
      title: "Sisley法国希思黎中国官方网站",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      requireAuth: false,
      disableLayout: true
    },
    component: () => import("../views/Jump.vue")
  },
  {
    path: "/sustainabilityView",
    name: "sustainability",
    meta: {
      title: "Sisley",
      content: {
        description: ""
      },
      isMaster: true,
      requireAuth: false,
      disableLayout: true
    },
    component: () => import("../views/sustainability/index.vue")
  },
  {
    path: "/qiyu_getDetailById",
    name: "qiyu_getDetailById",
    meta: {
      title: "希思黎商品ID搜索",
      content: {
        description: "。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("@/views/getDetailById.vue")
  },
  {
    path: "/demo",
    name: "Demo",
    meta: {
      isMaster: true,
      disableLayout: true
    },
    component: () => import("@/views/Demo.vue")
  },
  {
    path: "/error",
    name: "ErrorPage",
    meta: {
      title: "500 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true,
      disableLayout: true
    },
    component: () => import("@/views/ErrorPage.vue")
  },
  {
    path: "*",
    name: "NotFound",
    meta: {
      title: "404 | 希思黎",
      content: {
        description: "誉享全球的奢华植物美容品牌Sisley法国希思黎，声望源于对品质的不懈追求.不计时间、不计成本，用前沿保养科技珍萃凝练，成就款款美容臻品，呈现卓效植粹奢护体验，是您不可或缺的美颜挚选。"
      },
      isMaster: true
    },
    component: () => import("@/views/NotFound.vue")
  }
];

let timer4PageLoad = null;
const checkPageStatus = (route, interval = 100, callback) => {
  if (route?.meta?.loaded) {
    callback();
    // console.timeEnd("Check");
  } else {
    timer4PageLoad && clearTimeout(timer4PageLoad);
    timer4PageLoad = setTimeout(() => {
      // console.info("Checking");
      checkPageStatus(route, interval, callback);
    }, interval);
  }
};

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  routes,
  // eslint-disable-next-line no-unused-vars
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      if (to?.meta?.loaded != undefined) {
        return new Promise((resolve) => {
          if (to?.meta?.loaded) {
            resolve(savedPosition);
          } else {
            // console.time("Check");
            checkPageStatus(to, 100, () => resolve(savedPosition));
          }
        });
      } else {
        return savedPosition;
      }
    } else if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
});

export default router;
